import { Link } from 'react-router-dom'
import {useLogout} from '../hooks/useLogout'
import { useAuthContext} from '../hooks/useAuthContext'

const Navbar = () => {
    const {logout} = useLogout()
    const { user } = useAuthContext()

    const handleClick = () => {
        logout()
    }

    return (
        <header>
            <div className="container">
                <Link to="/" className="logo-container">
                    <img src={'/travelPlannerIcon.png'} alt="Ezy Tripz Logo" className="logo-img" />
                    <h1>Ezy Tripz</h1>
                </Link>
                <nav>
                    {user && (
                        <div>
                            <Link to="/settings">
                                <div className="material-symbols-outlined settings-btn">settings</div>
                            </Link>
                            <span><strong>{user.firstName} {user.lastName}</strong></span>
                            <button className="logout-btn" onClick={handleClick}>Log out</button>
                        </div>
                    )}
                    {!user && (
                        <div className="logged-out-text">
                            <Link to="/login">Login</Link>
                            <Link to="/signup">Signup</Link>
                        </div>
                    )}
                </nav>
            </div>
        </header>
    )
}

export default Navbar